import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { CcRequirement } from "server/models"
import {
    StoreType,
    RequirementsOnSelect,
    addModal,
} from "client/store"
import {
    TextButton,
    CrossIcon,
    Empty,
    ListWrapper,
    ListItem,
    ListItemTitle,
    DeleteListItemButton,
} from "client/components"

import RequirementList from "client/pages/cc/requirement/requirementList"


interface LinkRequirementsProps {
    linkedRequirements: readonly CcRequirement[]
    editAccess: boolean
    onAdd: RequirementsOnSelect
    onDelete: (requirement: CcRequirement) => void
}

const LinkRequirements = ({
    linkedRequirements,
    editAccess,
    onAdd,
    onDelete,
}: LinkRequirementsProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const addRequirement = () => {
        dispatch(addModal({
            key: "requirement",
            content: <RequirementList onSelectRequirements={onAdd} />,
        }))
    }

    return (
        <ListWrapper>
            {
                linkedRequirements.map((requirement) => (
                    <ListItem key={requirement.id}>
                        <ListItemTitle>{`#${requirement.uniqueId} - ${requirement.name}`}</ListItemTitle>
                        {
                            editAccess && (
                                <DeleteListItemButton onClick={() => onDelete(requirement)}>
                                    <CrossIcon />
                                </DeleteListItemButton>
                            )
                        }
                    </ListItem>
                ))
            }
            {
                !linkedRequirements.length
                && <Empty />
            }
            {
                editAccess
                && <TextButton onClick={addRequirement}>{lang.add}</TextButton>
            }
        </ListWrapper>
    )
}
export default LinkRequirements
